export const AUTH_API_BASE = '/auth';
export const CMS_RESOURCE_API_BASE = '/cms-resource/public/v1/resource';
export const CODE_LIST_API_BASE = '/codelist/public/v1/codelist';
export const KAHL_API_BASE = '/kahl/public/v1/kahl';

export const LOGIN_URL = AUTH_API_BASE + '/casLogin';
export const LOGOUT_URL = AUTH_API_BASE + '/casLogout';
export const REFRESH_JWT_ENDPOINT = AUTH_API_BASE + '/refreshJwt';
